import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as BrandingActions from './branding.actions';
import { catchError, concatMap, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { globalFailure } from './../../../app/@store/common.actions';
import * as _ from 'lodash';
import { LegacyPartnerApiService } from './../../../app/@shared/services/legacypartnerapi.service';
import { SkinData } from './branding.reducer';
import { SkinConfig } from '@gridscale/gs-services/skinning/skinconfig.model';

@Injectable()
export class BrandingEffects {
  readonly #api = inject(LegacyPartnerApiService);
  readonly #actions$ = inject(Actions);




  loadSkin$ = createEffect(() =>
    this.#actions$.pipe(
      ofType(
        BrandingActions.loadSkin,
        BrandingActions.patchSkinSuccess,
        BrandingActions.patchExternalLinksSuccess,
        // BrandingActions.patchLogoSuccess,
        // BrandingActions.patchBackgroundSuccess,
        // BrandingActions.patchFaviconSuccess,
        // BrandingActions.deleteLogoSuccess,
        // BrandingActions.deleteBackgroundSuccess,
        // BrandingActions.deleteFaviconSuccess
      ),
      concatMap(action => {
        return this.#api.get<{ skin_detail: SkinData }>('/api/v1/skin').pipe(
          map(result => {
            return BrandingActions.loadSkinSuccess({
              data: result.skin_detail,
              trigger_action: action
            });
          }),
          catchError(error => of(BrandingActions.loadSkinFailure({ error }), globalFailure({ error })))
        );
      })
    )
  );

  patchSkin$ = createEffect(() =>
    this.#actions$.pipe(
      ofType(
        BrandingActions.patchSkin,
      ),
      concatMap(action => {
        return this.#api.patch<{ skin_detail: SkinConfig }>('/api/v1/skin', action.data).pipe(
          map(result => {
            return BrandingActions.patchSkinSuccess({
              data: result.skin_detail
            });
          }),
          catchError(error => of(BrandingActions.patchSkinFailure({ error }), globalFailure({ error })))
        );
      })
    )
  );

  patchLogo$ = createEffect(() =>
    this.#actions$.pipe(
      ofType(
        BrandingActions.patchLogo
      ),
      concatMap(action => {
        return this.#api.postForm('/api/v1/skin/logo', action.data).pipe(
          map(result => {
            return BrandingActions.patchLogoSuccess();
          }),
          catchError(error => of(BrandingActions.patchLogoFailure({ error }), globalFailure({ error })))
        )
      })
    )
  );

  patchDarkmodeLogo$ = createEffect(() =>
    this.#actions$.pipe(
      ofType(
        BrandingActions.patchDarkmodeLogo
      ),
      concatMap(action => {
        return this.#api.postForm('/api/v1/skin/logo_dark', action.data).pipe(
          map(result => {
            return BrandingActions.patchDarkmodeLogoSuccess();
          }),
          catchError(error => of(BrandingActions.patchDarkmodeLogoFailure({ error }), globalFailure({ error })))
        )
      })
    )
  );

  patchBackground$ = createEffect(() =>
    this.#actions$.pipe(
      ofType(
        BrandingActions.patchBackground
      ),
      concatMap(action => {
        return this.#api.postForm('/api/v1/skin/background', action.data).pipe(
          map(result => {
            return BrandingActions.patchBackgroundSuccess();
          }),
          catchError(error => of(BrandingActions.patchBackgroundFailure({ error }), globalFailure({ error })))
        )
      })
    )
  );

  patchFavicon$ = createEffect(() =>
    this.#actions$.pipe(
      ofType(
        BrandingActions.patchFavicon
      ),
      concatMap(action => {
        return this.#api.postForm('/api/v1/skin/favicon', action.data).pipe(
          map(result => {
            return BrandingActions.patchFaviconSuccess();
          }),
          catchError(error => of(BrandingActions.patchFaviconFailure({ error }), globalFailure({ error })))
        )
      })
    )
  );

  deleteLogo$ = createEffect(() =>
    this.#actions$.pipe(
      ofType(
        BrandingActions.deleteLogo
      ),
      concatMap(action => {
        return this.#api.delete('/api/v1/skin/logo').pipe(
          map(result => {
            return BrandingActions.deleteLogoSuccess();
          }),
          catchError(error => of(BrandingActions.deleteLogoFailure({ error }), globalFailure({ error })))
        )
      })
    )
  );

  deleteDarkmodeLogo$ = createEffect(() =>
    this.#actions$.pipe(
      ofType(
        BrandingActions.deleteDarkmodeLogo
      ),
      concatMap(action => {
        return this.#api.delete('/api/v1/skin/logo_dark').pipe(
          map(result => {
            return BrandingActions.deleteDarkmodeLogoSuccess();
          }),
          catchError(error => of(BrandingActions.deleteDarkmodeLogoFailure({ error }), globalFailure({ error })))
        )
      })
    )
  );

  deleteBackground$ = createEffect(() =>
    this.#actions$.pipe(
      ofType(
        BrandingActions.deleteBackground
      ),
      concatMap(action => {
        return this.#api.delete('/api/v1/skin/background').pipe(
          map(result => {
            return BrandingActions.deleteBackgroundSuccess();
          }),
          catchError(error => of(BrandingActions.deleteBackgroundFailure({ error }), globalFailure({ error })))
        )
      })
    )
  );

  deleteFavicon$ = createEffect(() =>
    this.#actions$.pipe(
      ofType(
        BrandingActions.deleteFavicon
      ),
      concatMap(action => {
        return this.#api.delete('/api/v1/skin/favicon').pipe(
          map(result => {
            return BrandingActions.deleteFaviconSuccess();
          }),
          catchError(error => of(BrandingActions.deleteFaviconFailure({ error }), globalFailure({ error })))
        )
      })
    )
  );


  patchExternalLinks$ = createEffect(() =>
    this.#actions$.pipe(
      ofType(
        BrandingActions.patchExternalLinks
      ),
      concatMap(action => {
        return this.#api.patch('/api/v1/external_links', {
          ...action.data
        }).pipe(
          map(result => {
            return BrandingActions.patchExternalLinksSuccess();
          }),
          catchError(error => of(BrandingActions.patchExternalLinksFailure({ error }), globalFailure({ error })))
        )
      })
    )
  );

}
